export const shadow = {
    sm: '0px 0.5px 1px 0.5px rgba(0, 0, 0, 0.1)',
    md: '0px 2px 10px 0px rgba(0, 0, 0, 0.1)',
    lg: '0px 10px 20px 0px rgba(0, 0, 0, 0.1)',
    xl: '0px 20px 30px 0px rgba(0, 0, 0, 0.2)',
    primary: () => '0px 0px 0px 3px var(--primary)',
    outline: '0px 0px 0px 1px #000',
    border: '0px 1px 0px 0px #000',
};
